import { post, get } from '@/utils/request';

const url = {
  getAppSignUpInfo: '/goods/option/getAppSignUpInfo',
  getAppSignUpInfo_php: '/api/external.HealthyDetectSign/applyBefore',
  detectApply: '/healthy/auth/detect/apply',
  detectApply_php: '/api/external.HealthyDetectSign/apply',
  applyInfo: '/healthy/auth/detect/applyInfo',
};

export default {
  getAppSignUpInfo(params = {}, options = {}) {
    const isClinic = window.sessionStorage.getItem('isClinic')
    return post({
      url: isClinic?url.getAppSignUpInfo_php:url.getAppSignUpInfo,
      data: params,
      options,
    });
  },
  detectApply(params = {}, options = {}) {
    const isClinic = window.sessionStorage.getItem('isClinic')
    return post({
      url: isClinic?url.detectApply_php:url.detectApply,
      data: params,
      options,
    });
  },
  applyInfo(params = {}, options = {}) {
    return get({
      url: url.applyInfo,
      data: params,
      options,
    });
  },
};